import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { resourceScopeCleared, userScopeCleared } from '@krp/client-runtime'

/**
 * Намерение человека: какая карточка пары выбрана (И-6, И-14). Только выбор — пары, проценты и отметки живут в кэше запросов.
 * Выбранный, но не подтверждённый кнопкой товар не сохраняется (И-11): слайс не переживает обновление страницы.
 */
export interface SelectedCard {
  resourceId: string
  pairId: number
  /** Ключ выбранного товара в источнике. */
  key: string
}

export interface SelectionState {
  selected: SelectedCard | null
}

const initialState: SelectionState = { selected: null }

const selectionSlice = createSlice({
  name: 'duplicates/selection',
  initialState,
  reducers: {
    /** Клик по карточке: выбирает её; повторный клик по той же — снимает выбор; клик по второй карточке пары — переключает. */
    cardToggled(state, action: PayloadAction<SelectedCard>) {
      const next = action.payload
      const same =
        state.selected !== null &&
        state.selected.resourceId === next.resourceId &&
        state.selected.pairId === next.pairId &&
        state.selected.key === next.key
      state.selected = same ? null : next
    },
    selectionCleared(state) {
      state.selected = null
    },
    /** Решение по паре принято: её выбранная карточка больше не нужна. Выбор в другой паре остаётся. */
    pairResolved(state, action: PayloadAction<number>) {
      if (state.selected?.pairId === action.payload) state.selected = null
    },
  },
  extraReducers: (builder) => {
    // Выход или смена человека на устройстве стирает и выбор: следующий человек его не увидит.
    builder.addCase(userScopeCleared, () => initialState)
    builder.addCase(resourceScopeCleared, (state, action) => {
      if (state.selected?.resourceId === action.payload.resourceId) state.selected = null
    })
  },
})

export const { cardToggled, selectionCleared, pairResolved } = selectionSlice.actions
export const selectionReducer = selectionSlice.reducer
